import React, { PropsWithChildren, ReactElement, useEffect, useState } from 'react';
  import useTranslationLgs from '@hooks/i18n/useTranslation';
  import { Visibility } from '@components/framework/orders/validation.ts';

  interface ComponentProps {
    visibility: Visibility;
    switchComponent: ReactElement;
    defaultOpen?: boolean;
    onVisibilityChange?: (isOpen: boolean) => void;
    overrideVisibility?: boolean;
    dataTestId?: string;
  }

  const VisibilityComponent: React.FC<PropsWithChildren<ComponentProps>> = ({
    visibility,
    switchComponent,
    children,
    defaultOpen = false,
    onVisibilityChange,
    overrideVisibility,
    dataTestId
  }) => {
    const { tr } = useTranslationLgs();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
      setVisible(visibility === 'always' || defaultOpen);
    }, [visibility, defaultOpen]);

    useEffect(() => {
      onVisibilityChange?.(visible);
    }, [visible, onVisibilityChange]);

    if (visibility === 'never') return <></>;

    const isVisible = typeof overrideVisibility === 'boolean'
      ? overrideVisibility
      : visibility === 'always' || (visibility === 'optional' && visible);

    if (isVisible) {
      return <>{children}</>;
    }

    return React.cloneElement(switchComponent, { onClick: () => setVisible(true), dataTestId });
  };

  export default VisibilityComponent;